import { Grid } from "@mui/material";
import { useState } from "react";
import ReusableButton from "../../components/general/ReusableButton";
import TitleBar from "../../components/general/TitleBar";
import AnswerSection from "./AnswerSection";
import QuestionSection from "./QuestionSection";
import RecommendationSection from "./RecommendationSection";
import SettingsSection from "./SettingsSection";
import SolutionSection from "./SolutionSection";

const taskContainerStyle = {
  backgroundColor: "#F3F0F4",
  borderRadius: "0 0 12px 12px",
};
const buttonsContainerStyle = { marginRight: 40 };

export default function TaskPanel({
  task,
  setTask,
  taskIndex,
  isAdd,
  isReadOnly,
  onAddTask,
  onDeleteTask,
  onDuplicateTask,
  original,
  editAnswers,
  submittingSection,
  onSubmitSection,
}) {
  const isEdit = !isAdd;
  const [expandTask, setExpandTask] = useState(true);

  const updateField = (field, value) => {
    const newTask = structuredClone(task);
    newTask[field] = value;
    if (field === "title") {
      newTask.identifier = value.toLowerCase().trim().replace(/\s/g, "_");
    }
    setTask(newTask);
  };

  const displayTitle = isAdd
    ? `Task ${taskIndex + 1} - ${task.title}`
    : task.title || "Task";

  return (
    <Grid container>
      <TitleBar
        title={displayTitle}
        state={expandTask}
        setState={setExpandTask}
        main
      >
        {isAdd && (
          <div style={buttonsContainerStyle}>
            {taskIndex > 0 && (
              <ReusableButton
                text="Delete Task"
                fontSize={16}
                bgColor="#E83D4D"
                marginLeft={20}
                onClick={() => onDeleteTask(taskIndex)}
                iconType="delete"
              />
            )}
            <ReusableButton
              text="Duplicate Task"
              fontSize={16}
              bgColor="#F16774"
              marginLeft={20}
              onClick={() => onDuplicateTask(taskIndex + 1, task)}
              allowSpam
              iconType="copy"
            />
          </div>
        )}
      </TitleBar>
      {expandTask && (
        <Grid container style={taskContainerStyle}>
          <SettingsSection
            task={task}
            updateField={updateField}
            isReadOnly={isReadOnly}
            original={original}
            isEdit={isEdit}
            submittingSection={submittingSection}
            onSubmitSection={onSubmitSection}
          />
          <QuestionSection
            task={task}
            setTask={setTask}
            isReadOnly={isReadOnly}
            original={original}
            isEdit={isEdit}
            submittingSection={submittingSection}
            onSubmitSection={onSubmitSection}
          />
          <AnswerSection
            task={task}
            setTask={setTask}
            isReadOnly={isReadOnly}
            original={original}
            isEdit={isEdit}
            editAnswers={editAnswers}
            submittingSection={submittingSection}
            onSubmitSection={onSubmitSection}
          />
          <RecommendationSection
            task={task}
            setTask={setTask}
            isReadOnly={isReadOnly}
            original={original}
            isEdit={isEdit}
            submittingSection={submittingSection}
            onSubmitSection={onSubmitSection}
          />
          <SolutionSection
            task={task}
            updateField={updateField}
            isReadOnly={isReadOnly}
            original={original}
            isEdit={isEdit}
            submittingSection={submittingSection}
            onSubmitSection={onSubmitSection}
          />
        </Grid>
      )}
    </Grid>
  );
}
